import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography, Grid, MenuItem } from "@material-ui/core";
import { SelectValidator, ValidatorForm } from "react-material-ui-form-validator";
import { ArrowForwardSharp, ClearSharp, DoneSharp } from "@material-ui/icons";
import { getAreasFisicasAction } from "../../../../../actions/usuarios/areasFisicas";
import { FetchOrigenErrorReclamos } from "../../../../../actions/reclamos/reclamosActions";
import { AREAS_FISICAS } from "../../../../../utils/constants";
import ModalAbm from "../../../../compartidos/abms/ModalAbm";
import { FormComentarioExterno } from "./FormComentarioExterno";
import { anularReclamoExterno, finalizarReclamoExterno, updateDerivacionReclamoExterno } from "../../../../../actions/reclamos/reclamosExternosActions";

export const DerivacionesReclamosExternosMenu = (props) => {
  const dispatch = useDispatch();
  const { onCloseModalAuditar, fechaFin, fechaInicio } = props;
  const { solicitudSeleccionada = {} } = useSelector((state) => state.reclamos);
  const { areasFisicas } = useSelector((state) => state.areasFisicas);
  const { areasFisicasUsuario } = useSelector((state) => state.auth);
  const [openModalComentarioAnulado, setOpenModalComentarioAnulado] =
    useState(false);
  const [openModalCambioArea, setOpenModalCambioArea] = useState(false);
  const [openModalFinalizar, setOpenModalFinalizar] = useState(false);
  const [idAreaSeleccionada, setIdAreaSeleccionada] = useState(AREAS_FISICAS.COMUNICACIONES);
  const [idSubAreaSeleccionada, setIdSubAreaSeleccionada] = useState(null);




  useEffect(() => {
    dispatch(getAreasFisicasAction());
    dispatch(FetchOrigenErrorReclamos());
  }, [dispatch]);

  const onClickCambiarBandeja = () => {
    // setIdAreaSeleccionada(formValues.destino);
    // setIdSubAreaSeleccionada(formValues.subDestino);
    setOpenModalCambioArea(true);
  };

  const FinalizarSolicitud = () => {
    setOpenModalFinalizar(true);
  };

  const AnularSolicitud = () => {
    setOpenModalComentarioAnulado(true);
  };

  const onSubmit = () => {}

  return (
    <React.Fragment>
    <Typography
      variant="h6"
      style={{
        textAlign: "center",
        margin: "1.5rem 0",
      }}
    >
      Mover Bandeja:
    </Typography>
    <ValidatorForm onSubmit={onSubmit}>
      <Grid container justify="space-between" spacing={2}>

        <Grid item xs={12} md={5}>
          <SelectValidator
            fullWidth
            margin="normal"
            label="Área Destino"
            name="destino"
            disabled={false}
            value={areasFisicasUsuario.idArea === AREAS_FISICAS.COMUNICACIONES ? idAreaSeleccionada : AREAS_FISICAS.COMUNICACIONES}
            onChange={(e) => {
              setIdAreaSeleccionada(e.target.value);
              setIdSubAreaSeleccionada(null)
              // setearVariosValores({
              //   "destino": e.target.value,
              //   "subDestino": null,
              // });
            }}
            InputLabelProps={{ style: { fontWeight: "bold" } }}
            validators={["required"]}
            errorMessages={["Este campo es obligatorio"]}
            style={{ color: "#000" }}
          >
            {areasFisicas.map((e) => (
              <MenuItem key={e.idArea} value={e.idArea} disabled={areasFisicasUsuario.idArea !== AREAS_FISICAS.COMUNICACIONES && e.idArea !== AREAS_FISICAS.COMUNICACIONES}>
                {e.descripcionArea}
              </MenuItem>
            ))}
          </SelectValidator>
        </Grid>

        <Grid item xs={12} md={5}>
          {(idAreaSeleccionada !== null) && !(areasFisicas.find(e => e.idArea === idAreaSeleccionada).subAreas.length === 0) && (
            <SelectValidator
              fullWidth
              margin="normal"
              label="Subárea Destino"
              name="subDestino"
              disabled={idSubAreaSeleccionada === ""}
              value={idSubAreaSeleccionada}
              onChange={(e) => {
                setIdSubAreaSeleccionada(e.target.value)
                // setearValor("subDestino", e.target.value);
              }}
              InputLabelProps={{ style: { fontWeight: "bold" } }}
              validators={["required"]}
              errorMessages={["Este campo es obligatorio"]}
              style={{ color: "#000" }}
            >
              {idAreaSeleccionada && areasFisicas.find(e => e.idArea === idAreaSeleccionada).subAreas.map(subArea => (
                <MenuItem key={subArea.idSubArea} value={subArea.idSubArea}>
                  {subArea.descripcionSubArea}
                </MenuItem>
              ))}
            </SelectValidator>
          )
          }
        </Grid>
        <Grid item xs={12} md={2} style={{ display: 'flex', justifyContent: 'center' }} >
          <Button
            style={{
              margin: "0.5rem",
              backgroundColor: "#2199d9",
              color: "white",
            }}
            disabled={props.disabled}
            onClick={() => {
              onClickCambiarBandeja();
            }}
          >
            <ArrowForwardSharp />
            <Typography
              //variant="h6"
              style={{
                textAlign: "center",
                margin: "0.5rem",
              }}
            >
              Enviar
            </Typography>
          </Button>
        </Grid>

      </Grid>
    </ValidatorForm>
    {areasFisicasUsuario.idArea === AREAS_FISICAS.COMUNICACIONES && (
    <Typography
      variant="h6"
      style={{
        textAlign: "center",
        margin: "1.5rem 0",
      }}
    >
      Cambiar Estado Solicitud:
    </Typography>
    )}
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        flexWrap: "wrap",
      }}
    >
      {openModalFinalizar && (
        <ModalAbm
          title="Agregar Comentario"
          open={openModalFinalizar}
          setOpen={() => { }}
        >
          <FormComentarioExterno
            cerrarModal={() => {
              setOpenModalFinalizar(false);
              dispatch(
                finalizarReclamoExterno(
                  solicitudSeleccionada.id,
                  areasFisicasUsuario.idArea,
                  areasFisicasUsuario.idSubArea,
                  fechaInicio,
                  fechaFin
                )
              );
              onCloseModalAuditar(false);
            }}
            cancelarModal={() => {
              setOpenModalFinalizar(false);
            }}
            solicitud={solicitudSeleccionada.id}
            titulo={"Agregar Nota"}
            closeModalAuditar={props.onCloseModalAuditar}
            solicitudFinalizada={true}
          />
        </ModalAbm>
      )}
      {openModalComentarioAnulado && (
        <ModalAbm
          title="Agregar Comentario"
          open={openModalComentarioAnulado}
          setOpen={() => { }}
        >
          <FormComentarioExterno
            cerrarModal={() => {
              setOpenModalComentarioAnulado(false);
              dispatch(
                anularReclamoExterno(
                  solicitudSeleccionada.id,
                  areasFisicasUsuario.idArea,
                  areasFisicasUsuario.idSubArea,
                  fechaInicio,
                  fechaFin
                )
              );
              onCloseModalAuditar(false);
            }}
            cancelarModal={() => {
              setOpenModalComentarioAnulado(false);
            }}
            solicitud={solicitudSeleccionada.id}
            titulo={"Agregar Comentario"}
            closeModalAuditar={props.onCloseModalAuditar}
          />
        </ModalAbm>
      )}
      {openModalCambioArea && (
        <ModalAbm
          title="Agregar Comentario"
          open={openModalCambioArea}
          setOpen={() => { }}
        >
          <FormComentarioExterno
            cerrarModal={() => {
              setOpenModalCambioArea(false);
              dispatch(
                updateDerivacionReclamoExterno(
                  solicitudSeleccionada.id,
                  idAreaSeleccionada,
                  idSubAreaSeleccionada,
                  areasFisicasUsuario,
                  fechaInicio,
                  fechaFin,
                  solicitudSeleccionada.derivado,
                  solicitudSeleccionada.subDerivado
                )
              );
              onCloseModalAuditar(false);
            }}
            cancelarModal={() => {
              setOpenModalCambioArea(false);
            }}
            solicitud={solicitudSeleccionada.id}
            titulo={"Agregar Comentario"}
            closeModalAuditar={props.onCloseModalAuditar}
          />
        </ModalAbm>
      )}
      {areasFisicasUsuario.idArea === AREAS_FISICAS.COMUNICACIONES && (
        <Button
          style={{
            margin: "0.5rem",
            flexBasis: "30%",
            backgroundColor: "red",
            color: "white",
          }}
          disabled={
            props.disabled ||
            areasFisicasUsuario.idArea !== AREAS_FISICAS.COMUNICACIONES
          }
          variant="contained"
          onClick={() => AnularSolicitud()}
        >
          <ClearSharp />
          <Typography
            //variant="h6"
            style={{
              textAlign: "center",
              margin: "0.5rem",
            }}
          >
            Anular
          </Typography>
        </Button>
      )}
      {areasFisicasUsuario.idArea === AREAS_FISICAS.COMUNICACIONES && (
        <Button
          style={{
            margin: "0.5rem",
            flexBasis: "30%",
            backgroundColor: "green",
            color: "white",
          }}
          disabled={
            props.disabled ||
            areasFisicasUsuario.idArea !== AREAS_FISICAS.COMUNICACIONES
          }
          variant="contained"
          onClick={() => FinalizarSolicitud()}
        >
          <DoneSharp />
          <Typography
            //variant="h6"
            style={{
              textAlign: "center",
              margin: "0.5rem",
            }}
          >
            Finalizar
          </Typography>
        </Button>
      )}
    </div>
  </React.Fragment>
  )
}
